module.exports = __webpack_public_path__ + "static/media/admin.04141e7e.png";